/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { jQuery } from '../other/jquery-hooked.js';

/**
 * Manja Media Structure Overlays Widget ( .mjMediaStructureOverlaysWidget )
 *
 * methods:
 *  - TODO
 *
 * usage:
 *  $('#container').mjMediaStructureOverlaysWidget( { ... } )
 *
 */
(function($) {


	// using the new $.widget utility..
	$.widget( 'mj.mjMediaStructureOverlaysWidget', {

		options: {
			// media specs ...
			md_w: 1,				// image width
			md_h: 1,				// image height
			md_rotation: 0,			// image rotation
			media_bbox: [0,0,1,1],	// media_bbox ( [llx,lly,urx,ury] )
			ref_bbox: [0,0,1,1],	// reference bbox ( [llx,lly,urx,ury] )

			// clip (or zoom) region specs (in image dimensions, not in viewport dimensions!) ...
			md_c_x: 0,			// clip region x
			md_c_y: 0,			// clip region y
			md_c_w: null,		// clip region width (md_w used if null)
			md_c_h: null,		// clip region height (md_h used if null)
		},

		_create: function() {
			//var thisWidget = this;
			// init state
			this._overlays = [];
			this._elem_w = this.element.width();
			this._elem_h = this.element.height();
		},

		/*_setOption: function( k, v ) {
			this._super( k, v );
			this._draw_overlays();
		},*/

		_setOptions: function( options ) {
			this._super( options );
			this._draw_overlays();
		},

		_draw_box: function( x,y,w,h, id, type ) {
			// some fast rough clipping rules...
			if( x+w<0 || x> this._elem_w ) return;
			if( y+h<0 || y> this._elem_h ) return;
			// force min size (so even very tiny boxes become visible...)
			if( w<1 ) w = 1;
			if( h<1 ) h = 1;
			if( w>0 && h>0 ) {
				$('<div id="'+id+'" class="md-overlay-box md-sce-border-color-for-'+type+'" />')
					.css( {	left:x+'px',top:y+'px',width:w+'px',height:h+'px' } )
					.appendTo(this.element);
				/* actually not helpful...
				if( w>=20 && h>=8 ) {
					var type_str = type=='text_run' ? 'text' : type;
					ov_box.html('<span class="md-overlay-box-label md-sce-color-for-'+type+'">'+type_str+'</span>');
				}*/
			}
		},

		_translate_coords_box_space: function( fx, fy, media_box, ref_box ) {
			return [ fx-ref_box[0]+media_box[0], fy-ref_box[1]+media_box[1] ];
		},

		_scale_coords: function( p, sx, sy ) {
			return [ p[0]*sx, p[1]*sy ];
		},

		_draw_overlays: function( ) {
			var l = this._overlays.length;

			// remove previous overlays
			this.element.empty();
			// get current element dimensions
			this._elem_w = this.element.width();
			this._elem_h = this.element.height();

			// and (re)draw all overlays
			if( l>0 ) {
				// var mbox = this.options.media_bbox,
				var rbox = this.options.ref_bbox,
					bmp_w = this.options.md_w,
					bmp_h = this.options.md_h,
					bmp_w1 = (this.options.md_rotation==90||this.options.md_rotation==270) ? bmp_h : bmp_w,
					bmp_h1 = (this.options.md_rotation==90||this.options.md_rotation==270) ? bmp_w : bmp_h,
					box2bmp_w_scale = bmp_w1 / Math.abs(rbox[2]-rbox[0]),
					box2bmp_h_scale = bmp_h1 / Math.abs(rbox[3]-rbox[1]),
					bmp2view_w_scale = this._elem_w / (this.options.md_c_w===null?this.options.md_w:this.options.md_c_w),
					bmp2view_h_scale = this._elem_h / (this.options.md_c_h===null?this.options.md_h:this.options.md_c_h),
					elem,ebox,llp,urp,x,y,w,h,t,i;
				for( i=0; i<l; ++i ) {
					elem = this._overlays[i];
					ebox = elem.bbox;
					// compute coords in bitmap space
					llp = this._scale_coords(this._translate_coords_box_space(ebox[0],ebox[1],rbox,rbox),box2bmp_w_scale,box2bmp_h_scale);
					urp = this._scale_coords(this._translate_coords_box_space(ebox[2],ebox[3],rbox,rbox),box2bmp_w_scale,box2bmp_h_scale);
					x = llp[0];
					y = bmp_h1-urp[1];
					w = urp[0]-llp[0];
					h = urp[1]-llp[1];
					// apply rotation in bitmap space
					if( this.options.md_rotation==90 ) {
						// CW
						t = bmp_w-y-h;
						y = x;
						x = t;
						// swap w,h
						t=w; w=h; h=t;
					} else if( this.options.md_rotation==180 ) {
						x = bmp_w-x-w;
						y = bmp_h-y-h;
					} else if( this.options.md_rotation==270 ) {
						// CCW
						t = y;
						y = bmp_h-x-w;
						x = t;
						// swap w,h
						t=w; w=h; h=t;
					}
					// translate into cropped area
					x = x - this.options.md_c_x;
					y = y - this.options.md_c_y;
					// translate coords into view space
					x = x * bmp2view_w_scale;
					y = y * bmp2view_h_scale;
					w = w * bmp2view_w_scale;
					h = h * bmp2view_h_scale;

					// pin on pixel boundaries
					x = Math.floor(x-0.5);
					y = Math.floor(y-0.5);
					w = Math.floor(w);
					h = Math.floor(h);
					//x -= 0.5;
					//y -= 0.5;

					// add html
					this._draw_box(x,y,w,h,elem.id,elem.type);
				}
			}
			this.element.trigger('mjsoverlaysdrawn',[]);
		},

		addOverlay: function( type, bbox ) {
			this._overlays.push( { type:type, bbox:bbox } );
			this._draw_overlays();
		},
		setOverlays: function( overlays ) {
			this._overlays = overlays;
			this._draw_overlays();
		},
		clearOverlays: function() {
			this._overlays = [];
			this._draw_overlays();
		},

		clearViewUntilNextUpdate: function() {
			this.element.empty();
		},

		_destroy: function() {
			// stop all active timeouts
			// ...none yet...TODO...
			// remove all event handlers
			//$(document).off('keydown.mjMediaStructureOverlaysWidget');
			this.element.off('.mjMediaStructureOverlaysWidget');
			// remove all created elements
			this.element.empty();
		},

	} );

})(jQuery);

